import React from 'react';
import { ButtonWithGAClickButton, SectionSubTitle, SectionTitle, Typography } from 'common/components';
import {
  headerButton,
  headerSection,
  headerSectionInfo,
  headerSectionImage,
  headerSectionInfoContainer,
  headerSectionText,
  headerSectionTitle,
  pageTitle,
} from './header-section-styles';
import { HeaderSectionStructure } from './header-section-types';

type HeaderSectionProps = {
  headerConfig: HeaderSectionStructure;
  onConsultationSignupBtnClick: () => void;
};

/**
 * Вью хедер секции
 */
export const HeaderSection = ({ headerConfig, onConsultationSignupBtnClick }: HeaderSectionProps) => (
  <section className={headerSection}>
    <div className={headerSectionInfoContainer}>
      <SectionTitle as="h1" className={headerSectionTitle} variant="display">
        <SectionSubTitle as="span" className={pageTitle} margin="s" variant="h3">
          Проектирование и&nbsp;монтаж под ключ{' '}
        </SectionSubTitle>
        <img
          alt={headerConfig.img.alt}
          className={headerSectionImage}
          src={headerConfig.img.src}
          title={headerConfig.img.alt}
        />
        {headerConfig.title}
      </SectionTitle>
      <div className={headerSectionInfo}>
        <Typography adaptive={false} className={headerSectionText} variant="m" size="body_long">
          {headerConfig.description}
        </Typography>
        <ButtonWithGAClickButton
          className={headerButton}
          elementBlock={headerConfig.consultationSignupBtn.elementBlock}
          elementName={headerConfig.consultationSignupBtn.elementText}
          elementText={headerConfig.consultationSignupBtn.label}
          onClick={onConsultationSignupBtnClick}>
          {headerConfig.consultationSignupBtn.label}
        </ButtonWithGAClickButton>
      </div>
    </div>
  </section>
);
